let appMode = 'production';
if (window.location.origin === 'http://localhost:4000' || window.location.origin === 'http://localhost:3000') {
    appMode = 'stage';
}
let newlive = 'https://admin.staging.theperfumesmell.com/api/'
let stage = 'https://theperfumesmell.com/admin/api/'
let image = 'https://theperfumesmell.com/admin/api/';
if (appMode === 'production') {
    // newlive = 'http://tps.bloomingdalesnursery.co/admin/api/'
    image = 'https://admin.staging.theperfumesmell.com/api/';
} else {
    stage = 'http://localhost:8080/nihal/theperfumesmell/admin/public/api/'
    image = 'http://localhost:8080/nihal/theperfumesmell/admin/public/api/'
}
let URL = (appMode === 'production') ? newlive : stage;
let pathObj = {
    baseURL: URL,
    //Image URL
    imageURL: image,
    googleApiKey: 'AIzaSyCsPhnTTzy7vsbbJuThzzfSQOQRf1D4mWY',
    dashboard: "dashboard",
    brands: "brandsList",
    product: "product",
    productSample: "product-sample",
    productDetails: "product-details",
    productDetailsWeb: "product-details-web",
    CommonApi: "common-api",
    setting: "setting",
    guestUser: "guest-user",
    forgotPassword: "forgot-password",
    resetPassword: "reset-password",
    loginEmail: "login-email",
    login: "login",
    register: "register",
    otpVerify: "otp-verify",
    sendOtp: "send-otp",
    ResendOtp: "resend-otp",
    logout: "logout",
    profile: "get-profile",
    updateProfile: "update-profile",
    staticContent: "static-content",
    contactUs: "contact-us",
    subscribeNewsletter: "subscribe-newsletter",
    AddRemoveWishlist: 'add-remove-wishlist',
    ProductAvailability: 'product-availability',
    AddtoCart: 'add-to-cart',
    getCart: 'get-cart',
    cartDestroy: 'cart-destroy',
    getAllAddress: 'get-all-address',
    getWishList: 'get-wishlist',
    commonApi: "common-api",
    productRatingList: 'product-rating-list',
    getFilterData: 'get-filter-data',
    getCountry: "country",
    addEditAddress: "add-edit-address",
    getAllAddress: 'get-all-address',
    deleteAddress: "delete-address",
    getAddress: 'get-address',
    checkout: 'checkOutWeb',
    notificationList: 'notification-list',
    readNotification: 'read-notification',
    removeNotification: 'remove-notification',
    readAllNotification: 'read-all-notification',
    removeAllNotification: 'remove-all-notification',
    getOrder: "order-list",
    cancelOrder: "cancel-order",
    requestRefund: "request-refund",
    reorder: "reorder",
    orderDetails: "order-detail",
    rateProduct: "rate-product",
    walletList: "wallet-list",
    addMoney: "add-money",
    giftCard: "gift-card",
    submitGiftCard: "submit-gift-card",
    setDefaultAddress: "set-default",
    getOffer: "offers",
    notifyMe: "notify-me",
    comboDetail: "combo-detail",
    addToCombo: "add-to-combo",
    applyDiscount: "apply-discount",
    removeDiscount: "remove-discount",
    getStates: 'states',
    getNewsTicker: "news-ticker",
    newsTickerDetails: "news-ticker-details",
    setPreference: "set-preference",
    paymentByLink: 'paymentByLink1',
    tabbyByLink: 'tabby_checkout/payment',
    talyByLink: 'taly_checkout/payment',
    tapByLink: 'payment-by-link-tap',
    WalletByLink: 'WalletByLink',
    pickupStore: 'pickup-store',
    advanceSearch: 'v1/search',
    oldAdvanceSearch: 'advance_search',
    saleProduct: 'sale-product',
    sociallogin: "sociallogin",
    changeMobileNumber: "change-mobile-number",
    verifyMobileNumber: "verify-mobile-number",
    calculateShippingCharge: "calculateShippingCharge",
    trackingOrder: "tracking-order",
    likeReview: "review/like",
    getAreas: 'areas',
    recentKeywords: 'show-recent-keywords',
    searchSuggest: 'v1/search/suggest',
    blogs: 'blogs',
    blogDetail: 'blog',
    relatedBlogs: 'related-blogs',
    tapApplePayCharge: 'applepay-charge',
    waCheckoutResolve: 'wa-catalog/checkout/',
}
export default pathObj;
